import { useState } from "react";
import MapHeader from "./MapHeader";
import SearchSidebar from "./SearchSidebar";
import { useMapSearchStore } from "store/useMapSearchStore";
import LocationSelector from "./LocationSelector";
import Seo from "components/Seo";

interface MapLayoutProps {
    children: React.ReactNode;
}

export default function MapLayout({ children }: MapLayoutProps) {
    const [searchValue, setSearchValue] = useState("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [search, setSearch] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
    const [allStatus, setAllStatus] = useState(true);
    const { reFreshFilter, setRefreshFilter } = useMapSearchStore();

    return (
        <>
            <Seo type="console" pageTitle="관제서비스" />
            <div className="min-h-[100dvh] max-h-[100dvh] min-w-[1600px] overflow-hidden flex flex-col flex-1">
                <MapHeader
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                    search={search}
                    setSearch={setSearch}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    allStatus={allStatus}
                    setAllStatus={setAllStatus}
                />
                <div className="flex flex-1">
                    <SearchSidebar
                        searchValue={searchValue}
                        search={search}
                        startDate={startDate}
                        endDate={endDate}
                        // changeTab={() => setRefreshFilter(true)}
                        changeTab={() => {
                            setRefreshFilter(false);
                            setAllStatus(true);
                            setStartDate(null);
                            setEndDate(null);
                        }}
                        selectedStatus={selectedStatus}
                    />
                    <div className="flex-1">
                        <LocationSelector />
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}
